import React, { Component } from 'react';
import { FaChartPie, FaSortAlphaDown, FaReply, FaSortAlphaUp, FaRegListAlt } from 'react-icons/fa';
import S from './style'
// import Button from '@mui/material/Button';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import IconButton from '@mui/material/IconButton';
// import DeleteIcon from '@mui/icons-material/Delete';
import { PieChartOutlined, OrderedListOutlined, UndoOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
class Buttonsgroup extends Component {
  render() {
    let { degistir, detay, reset, pdf, disable } = this.props;
    return (
      <Space size={8} align="center">
        <Button type="primary" size={"large"} icon={<PieChartOutlined />} onClick={(e) => degistir(e)}>Grafik</Button>
        <Button type="default" size={"large"} icon={<OrderedListOutlined />} onClick={(e) => detay(e)}>Liste</Button>
        <Button type="dashed" size={"large"} icon={<UndoOutlined />} onClick={reset}>Sifirla</Button>
      </Space>
    )
  }
}
export default Buttonsgroup;
